import { render, staticRenderFns } from "./WarrantySeal.vue?vue&type=template&id=1b58c22e&"
import script from "./WarrantySeal.vue?vue&type=script&lang=ts&"
export * from "./WarrantySeal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports